import _ from "lodash";
import React from "react";
import classNames from "classnames";
import ACLStore from "lib/aclStore";

import classes from "./FeedListItem.scss";

import UserNameAvatar from "AppComponents/UserNameAvatar";
import ButtonDropdown from "UIComponents/ButtonDropdown";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import I18nHOC from "UIComponents/I18nHOC";
import { Dropdown, DropdownMenu, IconButton } from "@toddle-edu/ds-web";
import { DotsHorizontalOutlined } from "@toddle-edu/ds-icons";

const buttonDropDownContainerStyle = {
  marginTop: 4,
  width: "max-content",
  right: 0,
  marginBottom: 16,
};

const buttonDropDownItemStyle = {
  height: 40,
  fontSize: "1.4rem",
};

const tooltipContainerStyle = {
  maxWidth: "250px",
};

class FeedListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
    };
  }

  getHoverText(items) {
    let itemArray = [];
    items.map(item => {
      itemArray = [...itemArray, item.title];
    });

    return itemArray;
  }

  onUpdateShowDropDown = value => {
    this.setState({ showDropdown: value });
  };

  getColumnData = ({ column, columnData, id }) => {
    const {
      getCustomComponent,
      useNewActionsDropdown,
      t,
      tooltipHrefValue,
      onActionMenuItemClick,
      useCustomFuncForDefault = false,
      actionIconButtonProps,
    } = this.props;
    const actionMenuList = _.get(columnData, "actionMenuList", []);
    const item = _.get(columnData, "item");
    const showUid = ACLStore.can("FeatureFlag:ShowStudentUIDWithNameInReports");
    switch (column.type) {
      case "NAMEWITHIMAGE":
        return !_.isEmpty(columnData?.name) ? (
          <UserNameAvatar
            id={columnData.id}
            profileImage={columnData.profileImage}
            name={columnData.name}
            email={columnData.email}
            labelTags={columnData?.labelTags}
            shouldDynamicColor={columnData.shouldDynamicColor}
            tooltipHrefValue={tooltipHrefValue}
            customSubText={columnData.uid}
            viewMode={showUid ? "NAME_AND_CUSTOM_SUBTEXT" : "NAME_AND_EMAIL"}
          />
        ) : (
          <div className={classes.dashStyle}>-</div>
        );
      case "TEXTCOLUMN":
        return (
          <LinkWithTooltip
            tooltip={columnData}
            href={tooltipHrefValue}
            placement="top"
            tooltipContainerStyle={tooltipContainerStyle}
            isVisible={!column.hideTooltip}
            trigger={["hover", "focus"]}
          >
            <div
              tabIndex="0"
              className={classes.textCell}
              style={column?.columnDataStyle}
              dir="auto"
            >
              {columnData}
            </div>
          </LinkWithTooltip>
        );
      case "TEXTCOLUMNWITHSUBTEXT": {
        const customWithSubText = classNames("text-label-4", classes.subText);
        return (
          <LinkWithTooltip
            tooltip={columnData.label}
            href={tooltipHrefValue}
            placement="top"
            tooltipContainerStyle={tooltipContainerStyle}
            isVisible={!column.hideTooltip}
            trigger={["hover", "focus"]}
          >
            <div tabIndex="0" className={classes.textCell}>
              {columnData.label}
            </div>
            {columnData.subText && (
              <span className={customWithSubText}>{columnData.subText}</span>
            )}
          </LinkWithTooltip>
        );
      }
      case "INTCOLUMN":
        return <div className={classes.intCell}>{columnData}</div>;
      case "ARRAYCOLUMNWITHOVER":
        return (
          <MoreItemWithToolTip
            items={this.getHoverText(columnData ? columnData : [])}
            length={1}
            noItemText={t("common:no_with_label", { label: t(column.locale) })}
          />
        );
      case "ACTIONS": {
        return (
          !_.isEmpty(columnData) &&
          (useNewActionsDropdown ? (
            <Dropdown
              overlay={
                <DropdownMenu
                  options={actionMenuList}
                  onClick={({ key, domEvent }) => {
                    domEvent.stopPropagation();
                    onActionMenuItemClick({ key, item });
                  }}
                />
              }
            >
              <IconButton
                size={"small"}
                icon={<DotsHorizontalOutlined />}
                variant={"plain"}
                {...actionIconButtonProps}
              />
            </Dropdown>
          ) : (
            <ButtonDropdown
              onUpdateShowDropDown={this.onUpdateShowDropDown}
              authTabs={columnData}
              containerStyle={buttonDropDownContainerStyle}
              itemStyle={buttonDropDownItemStyle}
              disabled={_.get(column, "disabled", false)}
            />
          ))
        );
      }
      case "CUSTOM":
        if (getCustomComponent) {
          return getCustomComponent({
            column,
            columnData,
            id,
            t,
          });
        }
        break;
      default:
        if (useCustomFuncForDefault && getCustomComponent) {
          return getCustomComponent({
            column,
            columnData,
            id,
            t,
          });
        } else {
          return null;
        }
    }
    return null;
  };

  handleKeyDown = event => {
    if (
      event?.target === event?.currentTarget &&
      (event.code === "Enter" || event.code === "Space")
    ) {
      event.preventDefault();
      this.props.onItemClick(event);
    }
  };

  render() {
    const {
      listItem,
      columnList,
      rowWrapperClass,
      parentStyle,
      isItemClickEnable,
    } = this.props;

    let isItemClickable = false;
    if (listItem.isIndividualItemClickEnable != undefined) {
      isItemClickable = listItem.isIndividualItemClickEnable;
    } else {
      isItemClickable = isItemClickEnable;
    }

    const rowClasses = classNames(
      rowWrapperClass,
      classes.row,
      listItem.rowClass
    );
    return (
      <div
        className={rowClasses}
        style={{
          ...parentStyle,
          cursor: isItemClickable ? "pointer" : "auto",
        }}
        onClick={e => {
          if (!e.defaultPrevented && isItemClickable) {
            this.props.onItemClick(e);
          }
        }}
        tabIndex={0}
        onKeyDown={this.handleKeyDown}
      >
        {_.map(columnList, column => {
          const cellStyle = classNames(
            { [classes.cell]: true },
            { [classes.actionCell]: column.type == "ACTIONS" ? true : false },
            { [classes.hideCell]: column.showOnHover }
          );
          return (
            <div className={cellStyle} key={column.id} style={column.style}>
              {this.getColumnData({
                column,
                columnData:
                  typeof listItem[column.id] == "function"
                    ? listItem[column.id](
                        _.get(listItem[column.id], "extraParams", {})
                      )
                    : listItem[column.id],
                id: listItem.id,
              })}
            </div>
          );
        })}
      </div>
    );
  }
}

export default I18nHOC({ resource: ["common"] })(FeedListItem);
